var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"content scroll"},_vm._l((_vm.newsFeed),function(news){return _c('NewsListItem',{key:news.id,attrs:{"news":news}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }